import { render, staticRenderFns } from "./DonutChartSimplified.vue?vue&type=template&id=fcd3dc06&"
import script from "./DonutChartSimplified.vue?vue&type=script&lang=js&"
export * from "./DonutChartSimplified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports